<div class="empty-record" *ngIf="!loaderService.isLoading">
  <img
    src="https://i.ibb.co/RhqwZRK/no-record-found.png"
    alt=""
    *ngIf="!disableImage"
  />
  <div class="title-f">{{ title }}</div>
  <div class="desc-f" *ngIf="!disableSubTitle">Add a new record now!</div>
</div>
